var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaunch = function SvgLaunch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_488_11780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_488_11780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.975 13.25C3.6348 13.25 3.34547 13.131 3.107 12.893C2.869 12.6545 2.75 12.3652 2.75 12.025V3.975C2.75 3.6348 2.869 3.34547 3.107 3.107C3.34547 2.869 3.6348 2.75 3.975 2.75H7.4456C7.6108 2.75 7.7543 2.81067 7.8761 2.932C7.99743 3.0538 8.0581 3.1973 8.0581 3.3625C8.0581 3.5277 7.99743 3.6712 7.8761 3.793C7.7543 3.91433 7.6108 3.975 7.4456 3.975H3.975V12.025H12.025V8.5544C12.025 8.3892 12.0857 8.2457 12.207 8.1239C12.3288 8.00257 12.4723 7.9419 12.6375 7.9419C12.8027 7.9419 12.9462 8.00257 13.068 8.1239C13.1893 8.2457 13.25 8.3892 13.25 8.5544V12.025C13.25 12.3652 13.131 12.6545 12.893 12.893C12.6545 13.131 12.3652 13.25 12.025 13.25H3.975ZM6.25 9.75C6.13333 9.63333 6.075 9.48983 6.075 9.3195C6.075 9.14963 6.13333 9.00637 6.25 8.8897L11.1647 3.975H9.8956C9.7304 3.975 9.58713 3.91433 9.4658 3.793C9.344 3.6712 9.2831 3.5277 9.2831 3.3625C9.2831 3.1973 9.344 3.0538 9.4658 2.932C9.58713 2.81067 9.7304 2.75 9.8956 2.75H12.6375C12.8027 2.75 12.9462 2.81067 13.068 2.932C13.1893 3.0538 13.25 3.1973 13.25 3.3625V6.1044C13.25 6.2696 13.1893 6.41287 13.068 6.5342C12.9462 6.656 12.8027 6.7169 12.6375 6.7169C12.4723 6.7169 12.3288 6.656 12.207 6.5342C12.0857 6.41287 12.025 6.2696 12.025 6.1044V4.8353L7.0956 9.7647C6.97893 9.88137 6.84057 9.9397 6.6805 9.9397C6.51997 9.9397 6.37647 9.87647 6.25 9.75Z",
    fill: "#115180"
  }))));
};
export default SvgLaunch;